// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + "." + "ff0ad89630e3b6a851ea" + ".js";
};